import { createLoader } from '@meteor/data-hooks';
import { userClient } from '../client';
import { userLoader } from './user';

export let userDevicesLoader = createLoader({
  name: 'userDevices',
  parents: [userLoader],
  fetch: () => userClient.userSession.list({}),
  mutators: {}
});

export let useUserDevices = () => userDevicesLoader.use();
